import { HeadCell } from 'view/components/Table/components/TableHeader';
import { Withdrawal } from 'types/withdrawal';

export const headCells: HeadCell<Withdrawal>[] = [
  {
    id: 'createdAt',
    numeric: false,
    disablePadding: true,
    label: 'Created at',
    isSortable: true,
    width: 220,
  },
  {
    id: 'amount',
    numeric: true,
    disablePadding: false,
    label: 'Amount',
    isSortable: true,
    width: 120,
  },

  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Status',
    isSortable: true,
    width: 200,
  },
  {
    id: '_id',
    numeric: false,
    disablePadding: false,
    label: 'ID',
    width: 260,
  },
];
